import { Translatable } from './translatable';

import * as _ from 'lodash';

import { FileRef } from './file-ref';

export class Offer extends Translatable {
  public static readonly CLASS_NAME = 'Offer';
  public static readonly TITLE_KEY = 'title';
  public static readonly SUBTITLE_KEY = 'subtitle';
  public static readonly DESCRIPTION_KEY = 'desc';
  public static readonly CONTENT_KEY = 'content';
  public static readonly IMAGE_KEY = 'image';
  public static readonly ICON_KEY = 'icon';
  public static readonly SORT_ORDER_KEY = 'sortOrder';

  constructor() {
    super(Offer.CLASS_NAME);
  }

  // ===============================================================================================
  // Translations
  // ===============================================================================================

  public getTitle(lang: string): string {
    return this.getTranslation(Offer.TITLE_KEY, lang);
  }

  public setTitle(title: string, lang: string) {
    this.setTranslation(Offer.TITLE_KEY, title, lang);
  }

  public getSubtitle(lang: string): string {
    return this.getTranslation(Offer.SUBTITLE_KEY, lang);
  }

  public setSubtitle(subtitle: string, lang: string) {
    this.setTranslation(Offer.SUBTITLE_KEY, subtitle, lang);
  }

  public getDescription(lang: string): string {
    return this.getTranslation(Offer.DESCRIPTION_KEY, lang);
  }

  public setDescription(description: string, lang: string) {
    this.setTranslation(Offer.DESCRIPTION_KEY, description, lang);
  }

  public getContent(lang: string): string {
    return this.getTranslation(Offer.CONTENT_KEY, lang);
  }

  public setContent(content: string, lang: string) {
    this.setTranslation(Offer.CONTENT_KEY, content, lang);
  }

  public getImage(lang: string): FileRef {
    return this.getTranslation(Offer.IMAGE_KEY, lang);
  }

  public setImage(image: FileRef, lang: string) {
    this.setTranslation(Offer.IMAGE_KEY, image, lang);
  }

  public getIcon(lang: string): FileRef {
    return this.getTranslation(Offer.ICON_KEY, lang);
  }

  public setIcon(icon: FileRef, lang: string) {
    this.setTranslation(Offer.ICON_KEY, icon, lang);
  }

  // ===============================================================================================
  // Accessors
  // ===============================================================================================

  public get sortOrder(): number {
    return this.get(Offer.SORT_ORDER_KEY);
  }

  public set sortOrder(sortOrder: number) {
    this.set(Offer.SORT_ORDER_KEY, sortOrder);
  }
}

Parse.Object.registerSubclass(Offer.CLASS_NAME, Offer);



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/offer.ts